import { deleteOfficeStatusDetails } from "actions/Utilities/OfficeStatusDetails";
import { toast } from "components/toastNotification";
import { useMutation } from "react-query";
import { useRecoilState, useSetRecoilState } from "recoil";
import { editStateOfficeStatusDetails, officeStatusDetailsReFetching } from "../atoms/atoms";

export default function useDeleteOfficeStatusDetails() {
  const setActionEditState = useSetRecoilState(editStateOfficeStatusDetails);
  const [isReFetching, setIsReFetching] = useRecoilState(
    officeStatusDetailsReFetching
  );
  
  const { mutate } = useMutation(
    (ids: number[]) => deleteOfficeStatusDetails(ids),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire(
            "Deactivating Office Status Detail failed", 
            `Error: ${res.Message}`, 
            "error"
          );
        }
        else {
          if (res === "Success") {
            toast.fire("Success", "Office Status Detail Disabled Successfully", "success");
          } 
          else if (res === "Operation Failed!") {
              toast.fire("Disabling Office Status Detail failed", `Server Error: ${res}`, "error");
          } 
          else if (res === "Office Status Detail not found") {
              toast.fire("Disabling Office Status Detail failed", `Error: ${res}`, "error");
          } 
          else if (res.includes("Notification insert Failed")) {
              toast.fire("Success", `Office Status Detail Disabled Successfully, BUT ${res}`, "warning");
          } 
          else {
              toast.fire("Disabling Office Status Detail failed", res.Message, "error");
          }
        }
        
        // Redirect to View
        setActionEditState(false);
        
        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error) => {
        toast.fire("Disabling Office Status Detail failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
}
